import Vue from "vue"
import VueRouter from "vue-router"
import store from '@/store'

Vue.use(VueRouter)

function scrollBehavior(to, from, savedPosition) { return { x: 0, y: 0 } }

/**
 * Returns a boolean indicating whether the current user is an
 * Organization Admin.
 */
function userIsOrganizationAdmin() {
  return store.state.currentUser && store.state.currentUser.admin;
}

function userIsRole(roles = []) {
  return store.state.currentUser && roles.includes(store.state.currentUser.kind);
}


function planExpired(){
  if(store.state.currentUser){
    if (store.state.currentUser.plan_status === 'expired' || new Date(store.state.currentUser.expiration_date) < new Date()) return true;
    if (store.state.currentUser.is_subscription && new Date(store.state.currentUser.subscription_end_date) < new Date()) return true
  }else if(window.localStorage.getItem('currentUser')){
    store.state.currentUser = JSON.parse(window.localStorage.currentUser);
    if (store.state.currentUser.plan_status === 'expired' || new Date(store.state.currentUser.expiration_date) < new Date()) return true;
    if (store.state.currentUser.is_subscription && new Date(store.state.currentUser.subscription_end_date) < new Date()) return true;
  }
}

function redirectDashboard(next) {
  if (store.state.currentUser) {
    next("/user/dashboard")
  } else if (window.localStorage.getItem('currentUser')) {
    store.state.currentUser = JSON.parse(window.localStorage.currentUser)
    next("/user/dashboard")
  } else {
    next("/home")
  }
}

function authAdmin(next) {
  if(planExpired()) next("/user/account")
  if (userIsOrganizationAdmin()) {
    next()
  } else if (window.localStorage.getItem('currentUser')) {
    store.state.currentUser = JSON.parse(window.localStorage.currentUser)
    store.state.currentUser.admin ? next() : next("/log-in")
  } else {
    next("/log-in")
  }
}

function authAdminWithRole(next, roles = []) {
  if(planExpired()) next("/user/account")
  if (userIsOrganizationAdmin() || userIsRole(roles)) {
    next()
  } else if (window.localStorage.getItem('currentUser')) {
    store.state.currentUser = JSON.parse(window.localStorage.currentUser)
    store.state.currentUser.admin || roles.includes(store.state.currentUser.kind) ? next() : next("/log-in")
  } else {
    next("/log-in")
  }
}

// update with subscrition validation/current/free trial ect.
function authUser(next, to = null) {
  if(to && to.fullPath !== '/user/account' && planExpired()){
    next("/user/account")
  }
  if (store.state.currentUser) {
    if (userIsOrganizationAdmin() && !store.state.adminCurrentView) {
      next({ name: 'AdminGroups' })
    } else {
      next()
    }
  } else if (window.localStorage.getItem('currentUser')) {
    store.state.currentUser = JSON.parse(window.localStorage.currentUser)
    next()
  } else {
    next("/log-in")
  }
}

const defaultRoute = [{
  path: "/",
  beforeEnter(to, from, next) { redirectDashboard(next) }
}]

const staticRoutes = [
  { path: "/home", name: "Home", component: () => import("@/views/static/Home") },
  { path: "/about", name: "About", component: () => import("@/views/static/About") },
  { path: "/how-it-works", name: "HowItWorks", component: () => import("@/views/static/HowItWorks") },
  { path: "/organizations", name: "Organizations", component: () => import("@/views/static/Organizations") },
  { path: "/partners", name: "Partners", component: () => import("@/views/static/Partners") },
  { path: "/faq", name: "FAQ", component: () => import("@/views/static/FAQ") },
  { path: "/log-in", name: "LogIn", component: () => import('@/views/static/LogIn') },
  { path: "/logout", name: "LogOut", component: () => import('@/views/static/LogOut') },
  { path: "/privacy-policy", name: "PrivacyPolicy", component: () => import('@/views/static/PrivacyPolicy') },
  { path: "/terms-of-use", name: "TermsOfUse", component: () => import('@/views/static/TermsOfUse') },
  { path: "/security", name: "Security", component: () => import('@/views/static/Security') },
  {
    path: "/presentation-intro/:id",
    props: true,
    name: "TakeSurvey",
    component: () => import("@/views/static/ClientSurvey"),
  },
  {
    path: "/get-started",
    name: "GetStarted",
    component: () => import("@/views/static/SignUp")
  },
  {
    path: "/sign-up",
    name: "SignUpForm",
    component: () => import("@/views/static/SignUpForm")
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("@/views/static/ForgotPassword")
  },
  {
    path: "/reset",
    name: "ResetPassword",
    component: () => import("@/views/static/ResetPassword")
  },
  // { path: "/sign-up/:free_trial/:user_type/:plan_id",
  //   props: true,
  //   name: "SignUp",
  //   component: () => import('@/views/static/SignUp')
  // },
]
const groupsRoutes = [
  {
    path: "/groups/sign-up/:id",
    props: true,
    name: "SignUpGroup",
    component: () => import('@/views/static/SignUpFormGroups'),
  },
  {
    path: "/group-manager/sign-up/:id",
    props: true,
    name: "SignUpGroupManager",
    component: () => import('@/views/static/SignUpFormGroupManager'),
  },
]

const userRoutes = [
  {
    path: "/user/dashboard",
    name: "UserDashboard",
    component: () => import('@/views/user/Dashboard'),
    beforeEnter(to, from, next) {
      authUser(next, to)
    }
  },
  {
    path: "/user/responses/:id",
    props: true,
    name: "UserResponses",
    component: () => import('@/views/user/SurveyResults'),
    beforeEnter(to, from, next) { authUser(next, to) }
  },
  {
    path: "/user/responses/:id/actionsteps/:question_id",
    props: true,
    name: "UserActionSteps",
    component: () => import('@/views/user/ActionSteps'),
    beforeEnter(to, from, next) { authUser(next, to) }
  },
  {
    path: "/user/presentations/new",
    props: true,
    name: "NewUserPresentation",
    component: () => import('@/views/user/NewPresentation'),
    beforeEnter(to, from, next) { authUser(next, to) }
  },
  {
    path: "/user/resources/:resource",
    props: true,
    name: "UserResource",
    component: () => import('@/views/user/Resource'),
    beforeEnter(to, from, next) { authUser(next, to) }
  },
  {
    path: "/user/resources",
    name: "UserResources",
    component: () => import('@/views/user/Resources'),
    beforeEnter(to, from, next) { authUser(next, to) }
  },
  {
    path: "/user/profile",
    name: "Profile",
    component: () => import('@/views/user/Profile'),
    beforeEnter(to, from, next) { authUser(next, to) }
  },
  {
    path: "/user/account",
    name: "Account",
    component: () => import('@/views/user/Account'),
    beforeEnter(to, from, next) { authUser(next) }
  },
  {
    path: "/user/surveys/:id/send",
    props: true,
    name: "UserSurveySend",
    component: () => import('@/views/user/Send'),
    beforeEnter(to, from, next) { authUser(next, to) }
  },
  {
    path: "/user/surveys/:id",
    props: true,
    name: "UserSurveyPreview",
    component: () => import('@/views/user/Preview'),
    beforeEnter(to, from, next) { authUser(next, to) }
  },
  {
    path: "/user/surveys",
    name: "UserSurveys",
    component: () => import('@/views/user/Surveys'),
    beforeEnter(to, from, next) { authUser(next, to) }
  },
  {
    path: "/user/quick-tour/:type",
    name: "QuickTour",
    props: true,
    component: () => import('@/views/user/QuickTour'),
    beforeEnter(to, from, next) { authUser(next) }
  },
]

const adminRoutes = [
  {
    path: "/admin/surveys/new",
    name: "NewAdminSurvey",
    component: () => import('@/views/admin/NewSurvey'),
    beforeEnter(to, from, next) { authAdmin(next) }
  },
  {
    path: "/admin/surveys/:survey_id/questions/:id",
    props: true,
    name: "EditAdminQuestion",
    component: () => import('@/views/admin/EditQuestion'),
    beforeEnter(to, from, next) { authAdmin(next) }
  },
  {
    path: "/admin/surveys/:survey_id",
    props: true,
    name: "EditAdminSurvey",
    component: () => import('@/views/admin/EditSurvey'),
    beforeEnter(to, from, next) { authAdmin(next) }
  },
  {
    path: "/admin/surveys",
    name: "AdminSurveys",
    component: () => import('@/views/admin/Surveys'),
    beforeEnter(to, from, next) { authAdmin(next) }
  },
  {
    path: "/admin/surveyGroupResults/:group_id/:survey_id",
    props: true,
    name: "SurveyGroupResults",
    component: () => import('@/views/admin/SurveyGroupResults'),
    beforeEnter(to, from, next) { authAdmin(next) }
  },
  {
    path: "/admin/groups",
    name: "AdminGroups",
    component: () => import('@/views/admin/Groups'),
    beforeEnter(to, from, next) { authAdminWithRole(next, ["group_manager"]) }
  },
  {
    path: "/admin/groups/new",
    name: "NewGroup",
    component: () => import('@/views/admin/NewGroup'),
    beforeEnter(to, from, next) { authAdminWithRole(next, ["group_manager"]) }
  },
  {
    path: "/admin/groups/:id",
    props: true,
    name: "AdminEditGroup",
    component: () => import('@/views/admin/EditGroup'),
    beforeEnter(to, from, next) { authAdminWithRole(next, ["group_manager"]) }
  },
  {
    path: "/admin/groups/:id/managers/edit",
    props: true,
    name: "AdminEditGroupManager",
    component: () => import('@/views/admin/EditGroupManager.vue'),
    beforeEnter(to, from, next) { authAdmin(next) }
  },
  {
    path: "/admin/managers/new",
    props: true,
    name: "NewGroupManager",
    component: () => import('@/views/admin/NewGroupManager'),
    beforeEnter(to, from, next) { authAdmin(next) }
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import('@/views/Admin'),
    beforeEnter(to, from, next) { authAdminWithRole(next, ["group_manager"]) },
    children: [
      {
        path: "users",
        name: "admin-user-list",
        component: () => import('@/views/AdminUserList')
      }
    ]
  },

]

const routes = defaultRoute.concat(staticRoutes).concat(userRoutes).concat(adminRoutes).concat(groupsRoutes)

export default new VueRouter({ mode: "history", base: process.env.BASE_URL, routes, scrollBehavior })
